import { render, staticRenderFns } from "./Bid.vue?vue&type=template&id=6bc17735&scoped=true&"
import script from "./Bid.vue?vue&type=script&lang=js&"
export * from "./Bid.vue?vue&type=script&lang=js&"
import style0 from "./Bid.vue?vue&type=style&index=0&id=6bc17735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc17735",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc17735')) {
      api.createRecord('6bc17735', component.options)
    } else {
      api.reload('6bc17735', component.options)
    }
    module.hot.accept("./Bid.vue?vue&type=template&id=6bc17735&scoped=true&", function () {
      api.rerender('6bc17735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/detail/Bid.vue"
export default component.exports